import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import Loading from '../../loading';
import Server from '../../../functions/server';
export default class InCompletedJob extends React.Component {

    state = {
        fromDate: '2021-01-01', completedList: [],
        toDate: this.getFormatedDate(new Date(), 'toDate')
    }

    getFormatedDate(dates, interval) {
        if (interval > 0) {
          dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
        }
        let month = dates.getMonth() + 1; let date = dates.getDate();
        month = (month > 10) ? month : "0" + month;
        date = (date > 10) ? date : "0" + date;
        let x;
        if (interval == 'fromDate') {
          x = dates.getFullYear() + "-" + month + "-01";
        }
        else {
          x = dates.getFullYear() + "-" + month + "-" + date;
        }
        return x;
      }

    viewInComeletedJobs = () => {
        let context = this;
        let { item } = this.props;
        let { fromDate, toDate } = this.state;
        context.setState({ load: true, message: 'Getting Labor Details' })
        $.ajax({
            type: 'POST', data: { id: item.id, status: 2, fromDate, toDate }, 
            url: Server() + 'AdminControl/Labor/GetCompltedJob.php',
            success: function (completedList) {
                try {
                    completedList = JSON.parse(completedList);
                    context.setState({ completedList, load: false, dialog: true })
                } catch (error) {
                    context.setState({ load: false })
                    alert('Error')
                }
            },
            error: function (e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    handleChange = (type) => (e, {value}) => { alert(value) }

    print = () => {
        // let downloadLink;
        // let filename = 'JobCard';
        // let dataType = 'application/vnd.ms-excel';
        // let tableSelect = document.getElementById('table');
        // let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
        // filename = filename?filename+'.xls':'excel_data.xls';
        // downloadLink = document.createElement("a");
        // document.body.appendChild(downloadLink);
        // if(navigator.msSaveOrOpenBlob) {
        // let blob = new Blob(['\ufeff', tableHTML], {
        //     type: dataType
        // });
        // navigator.msSaveOrOpenBlob( blob, filename);
        // }
        // else {
        // downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
        // downloadLink.download = filename;
        // downloadLink.click();
        // }
    }

    render() {
        let { count, item } = this.props;
        let { dialog, fromDate, toDate, completedList } = this.state;
        let i = 1;
        return (
            <div>
                <u style={{cursor: 'pointer', color: 'blue'}} onClick={this.viewInComeletedJobs}>{count}</u>
                <Dialog open={dialog} maxWidth={"lg"}
                    onClose={ () => this.setState({ dialog: true })} aria-labelledby="max-width-dialog-title">
                    <DialogTitle style={{width: '1000px'}}>Completed Jobs</DialogTitle>
                    <DialogContent>
                        <div style={{display: 'flex'}}>
                            <div>
                                <TextField label="From" type="date"
                                    onChange={(e) => this.setState({fromDate: e.target.value})}
                                    defaultValue={fromDate} />
                            </div>
                            <div style={{marginLeft: '5px'}}>
                                <TextField label="To" type="date"
                                    onChange={(e) => this.setState({toDate: e.target.value})}
                                    defaultValue={toDate} />
                            </div>
                            <div style={{marginLeft: '5px'}}>
                                <br/>
                                <Button onClick={this.viewInComeletedJobs}>Submit</Button>
                            </div>
                        </div>
                        <table id='table' width='100%'>
                            <tr>
                                <th id='th'><center>Sino</center></th>
                                <th id='th'><center>Mechanic</center></th>
                                <th id='th'><center>Machine</center></th>
                                <th id='th'><center>Job</center></th>
                                <th id='th'><center>Date Of Work</center></th>
                                <th id='th'><center>Expected Delivery Date</center></th>
                            </tr>
                            {
                                completedList.map((c) => {
                                    return (
                                        <tr>
                                            <td>{i++}</td>
                                            <td>{item.name}</td>
                                            <td>{c.machine}</td>
                                            <td>{c.title}</td>
                                            <td>{c.date}</td>
                                            <td>{c.edate}</td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.print}>Print</Button>
                        <Button onClick={ () => this.setState({ dialog: false })}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

}